var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTelegramLight = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  id: "Layer_1",
  x: 0,
  y: 0,
  viewBox: "0 0 24 24",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#414141",
  d: "M21.2 4.2c-.2-.1-.4-.2-.6-.2-.1 0-.2 0-.4.1l-17.1 7c-.3.1-.6.5-.6.8 0 .4.2.7.6.8L7 14.4c.1.1.1.3.2.6.3.7.7 1.7 1.1 2.6.2.5.4.8.5 1.1.1.1.1.2.2.3 0 .1.1.1.1.1.1.2.3.2.4.2s.3-.1.4-.2l1.8-2 3.4 2.6c.2.1.4.2.6.2h.3q.45-.15.6-.6l4.9-14.2c.1-.2 0-.6-.3-.9M8.1 14.6c0-.2-.1-.3-.1-.4l.5-.3 4.9-3-3.2 3.5-.6.6c-.1.1-.1.2-.1.3s-.1.6-.1 1.1l-.1.9c0-.1-.1-.2-.1-.3-.4-.9-.8-1.8-1.1-2.4m2.1 2.8V17c0-.2 0-.4.1-.6v-.3l.6.4zm5.5 1.6L12 16.2l-1.3-1 .2-.2 5.6-6.1q.3-.3 0-.6c-.2-.2-.4-.2-.6-.1L8 13l-.7.4L3.5 12l17-7z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgTelegramLight);
export default ForwardRef;